module.exports = __webpack_public_path__ + "static/media/material.7a97e876.png";